import { Component, inject, ViewChild } from "@angular/core";
import { Dialog } from "primeng/dialog";
import { AssistantData } from "src/app/common/models/assistant-data.model";
import { FloatingAssistantChatService } from "src/app/common/services/floating-assistant-chat.service";

interface MaximizableDialog extends Dialog {
  maximized: boolean;
}

@Component({
  templateUrl: "./floating-assistant-chat.component.html",
  selector: "app-floating-assistant-chat",
  styleUrls: ["./floating-assistant-chat.component.scss"],
})
export class FloatingAssistantChatComponent {
  @ViewChild("chatDialog") chatDialog!: Dialog;
  protected readonly floatingAssistantChatService = inject(FloatingAssistantChatService);
  minimized = false;
  assistantData: AssistantData = new AssistantData(true);

  get isDialogMaximized(): boolean {
    return this.chatDialog ? (this.chatDialog as MaximizableDialog).maximized : false;
  }

  onHideChat(): void {
    this.floatingAssistantChatService.visible = false;
    this.minimized = false;
  }

  toggleMinimize(): void {
    this.minimized = true; // Set to true to minimize
  }

  restoreAssistant(): void {
    this.minimized = false; // Restore custom size
    if (this.chatDialog) {
      (this.chatDialog as MaximizableDialog).maximized = false;
    }
  }
}
